/* src/app/pages/ui-kit/components/message-view/message-view.component.scss */
.message-view {
  padding: 1rem;
}
.message-view .section {
  margin-bottom: 2rem;
}
.message-view .section h3 {
  margin-bottom: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
}
.message-view .section .messages-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
/*# sourceMappingURL=message-view.component.css.map */
